import { render, staticRenderFns } from "./AppointmentCalendar.vue?vue&type=template&id=4b2fb434&scoped=true&"
import script from "./AppointmentCalendar.vue?vue&type=script&lang=js&"
export * from "./AppointmentCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentCalendar.vue?vue&type=style&index=0&id=4b2fb434&prod&lang=scss&"
import style1 from "./AppointmentCalendar.vue?vue&type=style&index=1&id=4b2fb434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2fb434",
  null
  
)

export default component.exports